export default "__VITE_ASSET__8b319bf9__"